import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { ExecutingUnit } from '../entities/executingUnit';
import { EmployeeTtype } from '../entities/employeeTtype';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { CostCenter } from '../entities/costCenter';
import { IncomeSummaryDTO } from '../model/income-summary-dto';
import { HighAndLowDTO } from '../model/high-and-low-dto';
import { ParamsReportHighAndLow } from '../model/params-report-high-and-low';

interface ExtraSearchFields { 
  object? :any;
  executingUnit?: ExecutingUnit, 
  employeeType?: EmployeeTtype,
  startDate?: Date,
  endDate?: Date, 
  absenceType : Hhelpdesk,  
  costCenter : CostCenter, 
}

@Injectable()
export class ReportHighAndLowService extends BaseReportService<HighAndLowDTO> {

  public uri = '/api/reportHighAndLow/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance ReportHighAndLowService');
  }
  
  buildSentence(entity?: IncomeSummaryDTO, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );  
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchToViewTable( paramsReportHighAndLow : ParamsReportHighAndLow): Observable<any> {
         this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`; 
        return this.httpClient.post<any>(url, paramsReportHighAndLow  )
        .pipe(
          tap(response => {
            return response;
          }, 
           err =>{
            this.spinnerService.hideAll();
           this.notificationService.serverErrorMessage(err.status +' - '+ err.error.messages[0]);
            return new Observable<any>();
          },
           ()=>{
             this.spinnerService.hideAll();
           })
           ,
            catchError((err) => {
               return new Observable<Blob>();
           })
           
          ) ;
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-high-and-low.service.ts